import { IDmMucHocPhiTheoMonCopyRequest } from "../../model/request/category/dmMucHocPhiTheoMonCopyRequest";
import { IDmMucHocPhiTheoMonViewModelRequest } from "../../model/request/category/dmMucHocPhiTheoMonViewModelRequest";
import { apiClient } from "../apiClient";
import { IDmMucHocPhiTheoMon } from "./../../model/respone/category/IDmMucHocPhiTheoMon";
export const MUC_HOC_PHI_THEO_MON_ENDPOINT = "muc-hoc-phi-theo-mon";
export const mucHocPhiTheoMonApi = {
  Select: (payload: IDmMucHocPhiTheoMonViewModelRequest) =>
    apiClient.post(`${MUC_HOC_PHI_THEO_MON_ENDPOINT}/select-data`, payload),

  Save: (payload: IDmMucHocPhiTheoMon[]) =>
    apiClient.post(`${MUC_HOC_PHI_THEO_MON_ENDPOINT}/save-data`, payload),

  Lock: (payload: IDmMucHocPhiTheoMonViewModelRequest) =>
    apiClient.post(
      `${MUC_HOC_PHI_THEO_MON_ENDPOINT}/true/lock-or-unlock`,
      payload
    ),

  Unlock: (payload: IDmMucHocPhiTheoMonViewModelRequest) =>
    apiClient.post(
      `${MUC_HOC_PHI_THEO_MON_ENDPOINT}/false/lock-or-unlock`,
      payload
    ),
  Copy: (payload: IDmMucHocPhiTheoMonCopyRequest) =>
    apiClient.post(`${MUC_HOC_PHI_THEO_MON_ENDPOINT}/copy`, payload),
};
